module.exports = __webpack_public_path__ + "static/media/imperial.271192d9.jpg";